import { render } from "./PackagesIlets.vue?vue&type=template&id=2cafe23e&scoped=true"
import script from "./PackagesIlets.vue?vue&type=script&lang=js"
export * from "./PackagesIlets.vue?vue&type=script&lang=js"

import "./PackagesIlets.vue?vue&type=style&index=0&id=2cafe23e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cafe23e"]])

export default __exports__